import { setBearerToken } from '@/http'

// Token
export const setHeaderToken = token => setBearerToken(token)
export const setLocalToken = token => localStorage.setItem('token', token)
export const getLocalToken = () => localStorage.getItem('token')
export const deleteLocalToken = () => localStorage.removeItem('token')

// User
export const setLocalUser = user => localStorage.setItem('user', JSON.stringify(user))
export const getLocalUser = () => JSON.parse(localStorage.getItem('user') !== 'undefined' ? localStorage.getItem('user') : '{}')
